var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.lang == 'ar')?_c('span',[_vm._v(_vm._s(_vm.ar))]):_vm._e(),(_vm.lang == 'en')?_c('span',[_vm._v(_vm._s(_vm.en))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }